export const REACT_HOOK_FORM_VALIDATIONS = {
    REQUIRED: 'required',
    VALIDATE: 'validate',
};
